
<v-autocomplete
    v-if          = "items"
    :items        = "items"
    item-value    = "id"
    item-text     = "text"
    :label        = "label"
    v-model       = "value"
    @change       = "onChange"
    :hide-details = "hideDetails"
    :readonly     = "readonly"
    :clearable    = "clearable"
/>
